import { InjectionToken } from '@angular/core';

export const OHAYO_LOCALE = new InjectionToken<string>('ohayojp-locale');
